import { fetchWithAuth } from './authToken';
import API_BASE_URL from './urlHelper';

/**
 * Servicio para gestionar clientes sin préstamos activos
 */

/**
 * Obtiene la lista de clientes sin préstamos activos con paginación
 * @param {Object} filters - Filtros de búsqueda
 * @param {string} filters.search - Término de búsqueda (nombre, DNI, apellidos)
 * @param {string} filters.estado_cliente - Estado: 'todos', 'sin_prestamo_activo', 'sin_registro_prestamos'
 * @param {number} filters.per_page - Cantidad de registros por página
 * @param {number} filters.page - Número de página actual
 * @returns {Promise<Object>} Datos de clientes sin préstamos activos
 */
export const getClientesSinPrestamo = async (filters = {}) => {
    try {
        const params = new URLSearchParams();
        
        if (filters.search) {
            params.append('search', filters.search);
        }
        
        if (filters.estado_cliente && filters.estado_cliente !== 'todos') {
            params.append('estado_cliente', filters.estado_cliente);
        }
        
        if (filters.per_page) {
            params.append('per_page', filters.per_page);
        }
        
        if (filters.page) {
            params.append('page', filters.page);
        }

        const url = `${API_BASE_URL}/api/admin/clientes-sin-prestamo${params.toString() ? `?${params.toString()}` : ''}`;
        
        const response = await fetchWithAuth(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Error al obtener clientes sin préstamos activos');
        }

        return await response.json();
    } catch (error) {
        console.error('Error en getClientesSinPrestamo:', error);
        throw error;
    }
};

/**
 * Obtiene todos los clientes sin préstamos activos sin paginación
 * @param {Object} filters - Filtros de búsqueda
 * @returns {Promise<Object>} Todos los clientes sin préstamos activos
 */
export const getClientesSinPrestamoCompletos = async (filters = {}) => {
    try {
        const params = new URLSearchParams({
            get_all: 'true'
        });
        
        if (filters.search) {
            params.append('search', filters.search);
        }
        
        if (filters.estado_cliente && filters.estado_cliente !== 'todos') {
            params.append('estado_cliente', filters.estado_cliente);
        }

        const url = `${API_BASE_URL}/api/admin/clientes-sin-prestamo?${params.toString()}`;
        
        const response = await fetchWithAuth(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Error al obtener todos los clientes');
        }

        return await response.json();
    } catch (error) {
        console.error('Error en getClientesSinPrestamoCompletos:', error);
        throw error;
    }
};

/**
 * Obtiene estadísticas de clientes sin préstamos activos
 * @returns {Promise<Object>} Estadísticas generales
 */
export const getEstadisticasClientesSinPrestamo = async () => {
    try {
        const url = `${API_BASE_URL}/api/admin/clientes-sin-prestamo/estadisticas`;
        
        const response = await fetchWithAuth(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Error al obtener estadísticas');
        }

        return await response.json();
    } catch (error) {
        console.error('Error en getEstadisticasClientesSinPrestamo:', error);
        throw error;
    }
};
